import { createContext, useContext } from 'react'
import type { Table } from '@tanstack/react-table'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DataTableContext = createContext<Table<any> | null>(null)

export function useDataTableContext<TData>(): Table<TData> {
  const context = useContext(DataTableContext)
  if (!context) {
    throw new Error('useDataTableContext must be used within a DataTableRoot')
  }
  return context as Table<TData>
}

export { DataTableContext }
